module.exports = "/images/moto.gif";